<template lang="pug">
.index-wrap
  .wrap
    .swiper-wrap
      swiper(ref="mySwiper" :options="swiperOptions" @clickSlide="handleSwiperSlideClick" @slideChange="handleSlideChange")
        //- swiper-slide.swiper-item(v-for='(item, index) in banners', :key='"aa" + index')
        //-   a(:href="item.redirectUrl" target="_blank" @click="handleBanner($event, item.redirectUrl)")
        //-     img(:src='item.picUrl', alt="banner")
        swiper-slide.swiper-item.swiper-lazy(v-for='(item, index) in banners' :key="item.id + 'banner'" )
          h2.footer-shadow( ) {{item.title}}
          img(v-lazy="getBannerUrl(item)" alt="loklok banner")
      .swiper-pagination
      i.iconfont.icon-ic_player_back.my-swiper-button-prev
      i.iconfont.icon-ic_comme_more.my-swiper-button-next
    .content
      Album(v-for="(item, index) in indexData.recommendItems" :key="'album' + item.refId" :content="item" :type="index % 2" :sequence="index+1")
      client-only(v-if="needLocalLoad")
        infinite-loading(@infinite="infiniteHandler")
          div(slot="no-more")
      nuxt-link.see-more(v-if="!isInfiniteLoading" :to="localePath(morePath)") {{$t('indexPage.seeMore')}}
    //- .back-to-top-wrap(v-show="isShowBackToTop")
    //-   back-top-ercode(:hasBackTop="true")
</template>
<script>
import 'swiper/css/swiper.css'
import getStructuredJson from '@/util/structuredData'
import { pollingQuery } from '@/util/index'
import NavigationBar from '../components/navigation-bar'
import album from '@/components/index/album-card'
import backTopErcodeVue from '@/components/back-top-ercode.vue'
import { throttle } from 'throttle-debounce'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper.scss'
import vue from 'vue'

export default {
  name: 'index',
  components: {
    Swiper,
    SwiperSlide,
    Album: album,
    'back-top-ercode': backTopErcodeVue,
    NavigationBar
  },
  async asyncData({ app, $ua, redirect, query }) {
    let res = {
      recommendItems: []
    }
    let banners = []
    let seoRes = ''

    let resArr = []
    if (query.download) {
      redirect(app.localePath('/download_nd'))
    }
    await pollingQuery([{ fn: app.$api.getIndexList, params: { page: 0, size: 6 } }, { fn: app.$api.getIndexBanner, params: { size: 10 } }, { fn: app.$api.queryKeyword }])
      .then((r) => {
        resArr = r
      })
      .catch((e) => {
        redirect(app.localePath('/error'))
      })
    const [indexRes, bannersRes, seoData] = resArr
    return {
      banners: bannersRes?.value || banners,
      indexData: indexRes?.value || res,
      page: indexRes?.value?.page || res.page,
      needLocalLoad: (indexRes?.value?.recommendItems?.length || res.recommendItems.length) >= 6,
      seoKeyword: seoData?.value?.keyword || seoRes.keyword
    }
  },
  head() {
    return {
      title: this.$t('seo.index.title'),
      meta: [
        { name: 'keywords', content: `${this.seoKeyword ? this.seoKeyword + ',' : ''}${this.$t('seo.index.keywords')}` },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.index.description') + '- loklok'
        },
        { rel: 'canonical', href: 'https://loklok.top' + this.localePath('/') }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: [getStructuredJson.bread([{ name: this.$t('seo.index.title'), path: 'https://loklok.top' + this.localePath('/') }]), getStructuredJson.movieList(this.banners)]
        }
      ]
    }
  },
  data() {
    const newFilters = this.$store.getters.filterParams
    return {
      isShowBackToTop: false,
      banners: [],
      list: [],
      filterData: [],
      searchResults: [],
      isInfiniteLoading: false,
      page: 1,
      size: 6,
      html: '',
      selected: {},
      swiperOptions: {
        preventClicks: false,
        loop: true,
        autoplay: true,
        grabCursor: true,
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {},
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active'
        },
        navigation: {
          nextEl: '.iconfont.icon-ic_comme_more.my-swiper-button-next',
          prevEl: '.iconfont.icon-ic_player_back.my-swiper-button-prev'
        }
      },
      morePath: newFilters[0] ? `/channel/${newFilters[0].id}/${newFilters[0].name}` : '/all',
      hasUpdate: false
    }
  },
  computed: {
    filterParams() {
      return {
        size: this.size,
        sort: this.searchResults.length > 0 ? this.searchResults[this.searchResults.length - 1].sort : '',
        ...this.selected
      }
    },
    isEmpty() {
      return this.searchResults.length === 0
    }
  },
  methods: {
    handleBannerBury(item, index, type) {
      const tempWebsitePara = item.websiteParam.split('-')
      if (tempWebsitePara.length > 1) tempWebsitePara.shift()
      this.$LokBury.handleMD(
        {
          buryEventId: 'UM_Event_ContentClick',
          buryParams: {
            UM_Key_ContentName: tempWebsitePara.join('-'),
            UM_Key_ContentID: item.jumpParam,
            UM_Key_ContentType: type,
            UM_Key_SourceSection: `${item.id}#@#${item.title}`,
            UM_Key_SourceLocation: index + 1
          }
        },
        'click'
      )
    },
    getBannerUrl(item) {
      return this.$ua.isFromPc() ? `${item.imgUrl}?imageMogr2/format/webp/thumbnail/!75p` : `${item.imgUrl}?imageMogr2/format/webp/thumbnail/750/x`
    },
    handleSwiperSlideClick(index, reallyIndex) {
      this.onClickBanner(this.banners[reallyIndex], reallyIndex)
    },
    handleSlideChange(swiper, index) {
      if (!this.hasUpdate) {
        this.$refs.mySwiper.updateSwiper()
        this.hasUpdate = true
      }
    },
    onClickBanner(item, index) {
      // item = { id:1, imgUrl: '', isNeedLogin: false, jumpParam: '', jumpType: '', title: '' } }
      // jumpType = 跳转类型 MOVIE-电影，DRAMA-剧集，LINK-链接地址
      if (!item?.jumpType) return
      let url = ''
      if (item.jumpType === 'LINK') {
        url = item.jumpParam.indexOf('http') > -1 ? item.jumpParam : 'https://' + item.jumpParam
      } else if (item.jumpType === 'MOVIE') {
        this.handleBannerBury(item, index, '电影')
        url = this.localePath(`/detail/movie/${item.websiteParam || item.jumpParam}`)
      } else if (item.jumpType === 'DRAMA') {
        this.handleBannerBury(item, index, '剧集')
        url = this.localePath(`/detail/drama/${item.websiteParam || item.jumpParam}`)
      } else {
        url = '/'
      }
      window.open(url)
    },
    onSwiper(swiper) {
      console.log(swiper)
    },
    onSlideChange() {
      console.log('slide change')
    },
    async infiniteHandler($state) {
      console.log('infiniteHandler')
      if (this.isInfiniteLoading) return
      this.isInfiniteLoading = true
      const list = await this.load(this.filterParams)
      this.indexData?.recommendItems?.push(...list)
      if (list?.length < this.size) {
        $state && $state.complete()
      } else {
        $state && $state.loaded()
      }
      this.isInfiniteLoading = false
    },
    async load() {
      try {
        // 首页片单分页逻辑是; 从page=0开始请求; 下一个page是返回的内容中page字段的值 +1 得到的结果;不需要自己
        const res = await this.$api.getIndexList({ page: this.page + 1, size: this.size })
        this.page = res.page
        return res?.recommendItems || []
      } catch (e) {
        return []
      }
    },
    watchScroll() {
      document.addEventListener(
        'scroll',
        throttle(300, () => {
          var scrollY = document.documentElement.scrollTop || document.body.scrollTop
          if (scrollY > 1200) {
            !this.isShowBackToTop && (this.isShowBackToTop = true)
          } else {
            this.isShowBackToTop && (this.isShowBackToTop = false)
          }
        })
      )
    }
  },
  watch: {},
  created() {
    this.filterData.forEach((item) => {
      this.selected[item[0].key] = item[0].value
    })
  },
  mounted() {
    this.watchScroll()
  }
}
</script>

<style lang="sass" scoped>
.wrap
  max-width: 1440px
  margin: 0 auto
.swiper-wrap
  width: 100%
  height: 512px
  overflow: hidden
  position: relative
  margin-bottom: 54px
  border-radius: 8px
.swiper-container
  width: 100% !important
  height: 100% !important
:deep(.my-swiper-button-next)
  position: absolute
  color: #FEFEFE
  right: 27px
  top: 50%
  transform: translateY(-50%)
  width: 66px
  height: 110px
  z-index: 10
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  font-size: 110px
  opacity: 0.5
:deep(.my-swiper-button-prev)
  position: absolute
  color: #FEFEFE
  left: 27px
  top: 50%
  transform: translateY(-50%)
  width: 66px
  height: 110px
  z-index: 10
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  font-size: 110px
  opacity: 0.5
.swiper-item
  height: 100%
  position: relative
  img
    object-fit: cover
    width: 100%
    height: 100%
  .footer-shadow
    position: absolute
    left: 0
    right: 0
    bottom: 0
    height: 100px
    padding-left: 20px
    padding-right: 184px
    background: linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 100%)
    font-weight: bold
    font-size: 24px
    line-height: 100px
    color: $mainTextColor
    @include ellipsis
.swiper-pagination
  right: 23px
  bottom: 34px
  display: flex
:deep(.bullet)
  width: 6px
  height: 6px
  display: block
  border-radius: 50%
  background-color: $mainTextColor
  margin: 0 5px
  flex-shrink: 0
  flex-grow: 0
  opacity: 0.3
:deep(.bullet-active)
  width: 24px
  height: 6px
  border-radius: 6px
  background-color: #fff !important
  flex-shrink: 0
  flex-grow: 0
  margin: 0 5px
  opacity: 1
.content
  max-width: 1280px
  // min-width: 768px
  margin: 0 auto
.list
  @include base-flex
  flex-wrap: wrap
  padding-left: 100px
  padding-right: 100px
  a
    text-decoration: none
  .video-item
    width: 15.7%
    flex-shrink: 0
    margin-right: 1.16%
    margin-bottom: 36px
    img
      width: 100%
      height: 300px
      border-radius: 8px
    .title
      font-size: 16px
      color: #81868E
      letter-spacing: 0
      line-height: 24px
  .video-item:nth-child(6n+6)
    margin-right: 0
.seo-wrap
  height: 100px
  overflow: hidden
  position: absolute
  left: 0
  top: 0
  z-index: -1
  opacity: 0
.see-more
  width: 100%
  height: 38px
  border-radius: 8px
  background: $backgroundColor1
  color: $mainTextColor
  text-align: center
  line-height: 38px
  font-weight: 900
  font-size: 18px
  margin: 50px 0 63px
  cursor: pointer
  user-select: none
  display: block
  &:hover
    color: $mainColor
.back-to-top-wrap
  position: fixed
  z-index: 100
  bottom: 100px
  right: 100px
  // right: calc((100vw - 1240px)/2 - 200px)
  width: 160px
@media screen and (max-width: 1440px)
  .list
    padding: 0 20px
  .swiper-wrap
    width: 100%
    height: calc( 512 / 1280 * 100vw )
  .swiper-container
    width: 100% !important
    height: 100% !important
@media screen and (max-width: 1140px)
  .swiper-wrap
    margin-bottom: 34px
@media screen and (max-width: 960px)

@media screen and (max-width: 750px)
  .swiper-wrap
    margin-bottom: 24px
    min-height: 200px
    height: calc( 270 / 500 * 100vw )

  :deep(.my-swiper-button-next)
    display: none
  :deep(.my-swiper-button-prev)
    display: none
  .swiper-pagination
    right: 23px
    bottom: 20px
    display: flex
</style>
